export
const name: string = "Geomtext";

export
const preproc: string = ``;

export
const declaration: string = `
    // override default precision specified in defaultPrecision_fs
    precision lowp float;
    precision lowp int;

    uniform SMaterial u_material;
`;

export
const varyings: string = `
    varying float v_selected;
`;

export
const implementation: string = `
    void main()
    {
        SMaterial material = u_material;

        if (v_selected > 0.5) {
            material.ambient = SELECTED_MATERIAL_AMBIENT;
            material.diffuse = u_selected_material_diffuse;
        }

        gl_FragColor = applyLighting(material);

    #ifdef LOGDEPTH
        resolveLogarithmicDepth();
    #endif
    }
`;
